






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'
import {InputAuditoriaObservacaoSchema} from '@/schema/resource/AuditoriaObservacao/InputAuditoriaObservacaoSchema'

@Component
export default class PersistAuditoriaObservacaoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAuditoriaObservacaoSchema()
  auditoriaObservacao = new AuditoriaObservacao()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionCarga.listCarga()
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.auditoriaObservacao.getAuditoriaObservacao(id)
    }

    $.await.done('getAuditoriaObservacao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.auditoriaObservacao.persistAuditoriaObservacao()
    await Helper.successAndPush(
      'system.success.persist',
      '/auditoria-observacao/list'
    )
  }
}
